export default "assets/terroirs-map-overlay-cf02a1d5.png";